import {FETCH_SCHEDULE_BY_TUITION_AND_GENDER} from "../../actions";

export default (state = [], action) => {
    switch (action.type) {
        case FETCH_SCHEDULE_BY_TUITION_AND_GENDER:
            return action.payload;
        default:
            return state;
    }
};